import ApiService from './api.service'

const PhotoService = {
  index (entityType = undefined, entityUuid = undefined, cursor) {
    return ApiService.get('api/photos', {
      params: {
        cursor,
        entityType,
        entityUuid
      }
    })
  },

  store (data) {
    return ApiService.post('api/photos', data)
  },

  updateIsHighlighted (photoUuid, isHighlighted) {
    return ApiService.putWithoutLoading('api/photos/' + photoUuid + '/is-highlighted', {
      isHighlighted
    })
  },

  delete (photoUuid) {
    return ApiService.deleteWithoutAsking('api/photos/' + photoUuid)
  },

  rotate (photoUuid, direction) {
    return ApiService.putWithoutLoading(`api/photos/${photoUuid}/rotate`, {
      direction
    })
  },

  getTags (photoUuid, ignoreEntityType = undefined) {
    return ApiService.get(`api/photos/${photoUuid}/tags`, {
      params: {
        ignoreEntityType
      }
    })
  },
  addTag (photoUuid, data) {
    return ApiService.postWithoutLoading(`api/photos/${photoUuid}/tags`, data)
  },
  deleteTag (photoUuid, data) {
    return ApiService.deleteWithoutAsking(`api/photos/${photoUuid}/tags`, {
      params: {
        entityType: data.entityType,
        entityUuid: data.entityUuid
      }
    })
  },
  getGameEntityOptions (gameUuid) {
    return ApiService.get(`api/photos/tag-options/game/${gameUuid}`)
  },
  searchTagOptions (query) {
    return ApiService.get('api/photos/tag-options/search', { params: { query } })
  }
}

export default PhotoService
